import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconColumnAlt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4 13.5C4 13.1893 4.32119 12.9375 4.71739 12.9375H13.2826C13.6788 12.9375 14 13.1893 14 13.5C14 13.8107 13.6788 14.0625 13.2826 14.0625H4.71739C4.32119 14.0625 4 13.8107 4 13.5Z",
			fill: "#33373D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 10.5C4 10.1893 4.32119 9.9375 4.71739 9.9375H13.2826C13.6788 9.9375 14 10.1893 14 10.5C14 10.8107 13.6788 11.0625 13.2826 11.0625H4.71739C4.32119 11.0625 4 10.8107 4 10.5Z",
			fill: "#33373D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 7.5C4 7.18934 4.32119 6.9375 4.71739 6.9375H13.2826C13.6788 6.9375 14 7.18934 14 7.5C14 7.81066 13.6788 8.0625 13.2826 8.0625H4.71739C4.32119 8.0625 4 7.81066 4 7.5Z",
			fill: "#33373D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 4.5C4 4.18934 4.32119 3.9375 4.71739 3.9375H13.2826C13.6788 3.9375 14 4.18934 14 4.5C14 4.81066 13.6788 5.0625 13.2826 5.0625H4.71739C4.32119 5.0625 4 4.81066 4 4.5Z",
			fill: "#33373D"
		})
	]
});
export { SvgIconColumnAlt as ReactComponent };
